// extracted by mini-css-extract-plugin
export default {"done":"IgnoreIcon_done__H+TJa","btnAnimation":"IgnoreIcon_btnAnimation__gA5Fp","done__G":"IgnoreIcon_done__G__quMv8","done__P":"IgnoreIcon_done__P__kPsgK"};